export default class ApiError extends Error {
    public httpStatusCode: number
    public internalErrorKey: string

    constructor(httpResponseCode: number, internalErrorKey: string, message: string) {
        super(message)
        this.httpStatusCode = httpResponseCode
        this.internalErrorKey = internalErrorKey
    }
}



// WEBPACK FOOTER //
// ./src/Errors/ApiError.ts